// MOBILE FIX
// TOUCH OR NO-TOUCH, THAT IS THE QUESTION!
// SCROLL/SNAP PANELS
// SCROLL SPY
// SCROLL-TO ANIMATION FOR ANCHOR LINKS
// SLIDER (SWIPER JS)


//
// =MOBILE FIX
// --------------------------------------------------

// set (safari) theme color to match page bg color
var metaTC = document.createElement('meta');
metaTC.name = "theme-color";
metaTC.content = "#212121";
document.getElementsByTagName('head')[0].appendChild(metaTC);

// check real viewport height
const appHeight = () => {
  const doc = document.documentElement
  doc.style.setProperty('--app-height', `${window.innerHeight}px`)
}
window.addEventListener('resize', appHeight)
appHeight();

// hero cta: scroll to video
document.getElementById('mobileScrollToVideo').addEventListener('click', () => {
  document.getElementById('video').scrollIntoView({behavior: 'smooth'});
});


//
// =TOUCH OR NO-TOUCH, THAT IS THE QUESTION!
// --------------------------------------------------

function isTouchDevice() {
  return true == ("ontouchstart" in window || window.DocumentTouch && document instanceof DocumentTouch);
}
if (isTouchDevice() === true) {
  $("body").toggleClass("touch");
} else {
  $("body").toggleClass("no-touch");
}


//
// =SCROLL/SNAP PANELS
// --------------------------------------------------

if (document.body.classList.contains('no-touch')) {
  const defaultSnapOptions = {
    container: document.body,
    panelSelector: '.msdw-section-fs',
    directionThreshold: 150,
    delay: 0,
    duration: 300,
    easing: function(t) { return t },
  };

  new PanelSnap(defaultSnapOptions);
}


//
// =SCROLL SPY
// --------------------------------------------------

const sections = document.querySelectorAll('section[data-scroll-spy]');

const cb = (entries) => {
  entries.forEach((entry) => {
    const id = entry.target.getAttribute('id');
    entry.isIntersecting ?
      document.querySelector(`a[data-scroll-spy][href="#${id}"]`).classList.add('msdw-nav-anchor-active') :
      document.querySelector(`a[data-scroll-spy][href="#${id}"]`).classList.remove('msdw-nav-anchor-active');
  });
};

const observer = new IntersectionObserver(cb, {
  // root
  rootMargin: '-50%'
  // threshold: [0.25, 0.5]
  // threshold: [0.5, 0.75]
});

sections.forEach((el) => observer.observe(el));


//
// =SCROLL-TO ANIMATION FOR ANCHOR LINKS
// --------------------------------------------------

$('.msdw-nav-anchor').click(function() {
  if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
    var target = $(this.hash);
    target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
    if (target.length) {
      var offsetValue = 0;
      if ( window.innerWidth <= 767 ) {
        offsetValue;
        // console.log(offsetValue);
      } else {
        offsetValue = 0;
        // console.log(offsetValue);
      }

      $('html,body').animate({
        scrollTop: target.offset().top - offsetValue
      }, 900);
      return false;
    }
  }
});


//
// =SLIDER (SWIPER JS)
// --------------------------------------------------

const sliderShoes = new Swiper('#sliderShoes', {
  slidesPerView: 1,
  spaceBetween: 0,
  effect: "fade",
  fadeEffect: { crossFade: true },
  speed: 500,
  loop: false,
  autoplay: {
    delay: 2500,
    disableOnInteraction: false,
  },
});

var sliderProducts = new Swiper('.msdw-slider-gallery', {
  slidesPerView: 1.1,
  spaceBetween: 10,
  loop: false,
  breakpoints: {
    600: {
      slidesPerView: 1.43,
      spaceBetween: 15,
    },
  },
  // autoplay: {
  //   delay: 2500,
  //   disableOnInteraction: false,
  // },
});


var sliderFeaturesThumbs1 = new Swiper('#sliderFeaturesThumbs1', {
  slidesPerView: 5,
  watchSlidesProgress: true,
});

var sliderFeatures1 = new Swiper('#sliderFeatures1', {
  slidesPerView: 1.5,
  spaceBetween: 10,
  loop: false,
  breakpoints: {
    600: {
      slidesPerView: 2,
      spaceBetween: 15,
    },
    900: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
  },
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
  },
  thumbs: {
    swiper: sliderFeaturesThumbs1
  }
});


var sliderFeaturesThumbs2 = new Swiper('#sliderFeaturesThumbs2', {
  slidesPerView: 5,
  watchSlidesProgress: true,
});

var sliderFeatures2 = new Swiper('#sliderFeatures2', {
  slidesPerView: 1.5,
  spaceBetween: 10,
  loop: false,
  breakpoints: {
    600: {
      slidesPerView: 2,
      spaceBetween: 15,
    },
    900: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
  },
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
  },
  thumbs: {
    swiper: sliderFeaturesThumbs2
  }
});
